import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import UserService from '../../services/UserService';
import EntityService from '../../services/EntityService'; // Correct service for entities
import { useNavigate, useParams } from 'react-router-dom';

const UserEdit = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [roleId, setRoleId] = useState('');
  const [departmentId, setDepartmentId] = useState('');
  const [countryId, setCountryId] = useState('');
  const [entityId, setEntityId] = useState('');
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [countries, setCountries] = useState([]);
  const [entities, setEntities] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetchUser();
    fetchRoles();
    fetchDepartments();
    fetchCountries();
    fetchEntities(); // Fetch entities using EntityService
  }, []);

  const fetchUser = async () => {
    try {
      const data = await UserService.get(id);
      setFirstName(data.first_name);
      setLastName(data.last_name);
      setEmail(data.email);
      setRoleId(data.role_id);
      setDepartmentId(data.department_id);
      setCountryId(data.country_id);
      setEntityId(data.entity_id);
    } catch (error) {
      console.error('Error fetching user:', error);
    }
  };

  const fetchRoles = async () => {
    try {
      const data = await UserService.getRoles();
      setRoles(data);
    } catch (error) {
      console.error('Error fetching roles:', error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const data = await UserService.getDepartments();
      setDepartments(data);
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  const fetchCountries = async () => {
    try {
      const data = await UserService.getCountries();
      setCountries(data);
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
  };

  const fetchEntities = async () => {
    try {
      const data = await EntityService.getAll();
      setEntities(data);
    } catch (error) {
      console.error('Error fetching entities:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await UserService.update(id, {
        first_name: firstName,
        last_name: lastName,
        email,
        role_id: roleId,
        department_id: departmentId,
        country_id: countryId,
        entity_id: entityId,
      });
      Swal.fire('Updated!', 'User updated successfully.', 'success');
      navigate('/users'); // Redirect to user list
    } catch (error) {
      console.error('Error updating user:', error);
      Swal.fire('Error!', 'An error occurred while updating the user.', 'error');
    }
  };

  const handleCancel = () => {
    navigate('/users'); // Redirect to user list
  };

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-md-6">
          <div className="card shadow-lg border-0 rounded-lg">
            <div className="card-body">
              <h3 className="card-title text-primary">
                <i className="ti-user mr-2"></i> Edit User
              </h3>
              <p className="card-description text-muted">
                Modify the user details below and click <strong>Update</strong> to save changes.
              </p>

              <form onSubmit={handleSubmit}>
                {/* First Name */}
                <div className="form-group">
                  <label htmlFor="firstName"><strong>First Name</strong></label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="firstName"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                </div>

                {/* Last Name */}
                <div className="form-group">
                  <label htmlFor="lastName"><strong>Last Name</strong></label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="lastName"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                </div>

                {/* Email */}
                <div className="form-group">
                  <label htmlFor="email"><strong>Email</strong></label>
                  <input
                    type="email"
                    className="form-control form-control-sm"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                {/* Role */}
                <div className="form-group">
                  <label htmlFor="roleId"><strong>Role</strong></label>
                  <select
                    id="roleId"
                    className="form-control form-control-sm"
                    value={roleId}
                    onChange={(e) => setRoleId(e.target.value)}
                    required
                  >
                    <option value="">Select Role</option>
                    {roles.map((role) => (
                      <option key={role.id} value={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Department */}
                <div className="form-group">
                  <label htmlFor="departmentId"><strong>Department</strong></label>
                  <select
                    id="departmentId"
                    className="form-control form-control-sm"
                    value={departmentId}
                    onChange={(e) => setDepartmentId(e.target.value)}
                    required
                  >
                    <option value="">Select Department</option>
                    {departments.map((department) => (
                      <option key={department.id} value={department.id}>
                        {department.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Country */}
                <div className="form-group">
                  <label htmlFor="countryId"><strong>Country</strong></label>
                  <select
                    id="countryId"
                    className="form-control form-control-sm"
                    value={countryId}
                    onChange={(e) => setCountryId(e.target.value)}
                    required
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Entity */}
                <div className="form-group">
                  <label htmlFor="entityId"><strong>Entity</strong></label>
                  <select
                    id="entityId"
                    className="form-control form-control-sm"
                    value={entityId}
                    onChange={(e) => setEntityId(e.target.value)}
                  >
                    <option value="">Select Entity</option>
                    {entities.map((entity) => (
                      <option key={entity.id} value={entity.id}>
                        {entity.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Buttons */}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary btn-sm mr-2">
                    <i className="ti-check"></i> Update
                  </button>
                  <button type="button" className="btn btn-light btn-sm" onClick={handleCancel}>
                    <i className="ti-close"></i> Cancel
                  </button>
                </div>
              </form>
            </div>
            <div className="card-footer text-muted text-center">
              Ensure all required fields are filled before updating the user.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserEdit;
